export default __webpack_public_path__ + "static/media/passion-logo.dfd50ac5.png";